// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CatButtonGroup_wrapper__8zFF7","button-group":"CatButtonGroup_button-group__XaQ_t"};